import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';
import {isInvalidToken} from '../../consts/icc/iccResponseErrorTypes';
import * as gigyaService from '../gigya/gigyaService';
import HttpErrorHandlerService from '../httpErrorHandlerService';
import marketTypeService from '../marketTypeService';
import iccService from './iccService';

const iccResponseErrorCheckService = (error, isHandleError = true, isAnonymousUserAllowed) => {
    const isAuthError = error?.response?.status === httpErrorsTypes.NOT_AUTHORIZED;
    const isInvalid = isInvalidToken(error);
    const isDCE2 = marketTypeService.isDCE2();

    if (isAuthError) {
        return iccService.refreshIccTokenIfAllowed(isAnonymousUserAllowed);
    } else if (isInvalid && isDCE2) {
        return gigyaService.refreshGigyaToken();
    } else {
        if (isHandleError) {
            new HttpErrorHandlerService().handleError(error);
        }
        throw error;
    }
};

export default iccResponseErrorCheckService;
